// The full chat page's header (TOM-709, the Marina chat spec): Neo's mark,
// "Neo", the boat and the conversation, and (+) New chat. The chat box's +
// menu keeps its own New chat. Home's chat keeps its own header (NeoChat.tsx).

import type { ReactNode } from 'react';

import { Icon } from '../ui/Icon';

export function NeoChatHeader({
  boatName,
  title,
  onNewChat,
  sources,
  actions,
}: {
  /** Null until the chat's context names the boat. */
  boatName: string | null;
  /** "Main chat", the chat's first question, or "New chat". */
  title: string;
  onNewChat: () => void;
  /**
   * Sources (TOM-710): Behind the answer on the newest answer that has a
   * record, where the page has room for it.
   */
  sources?: { open: boolean; onToggle: () => void };
  /** More buttons after New chat: home's docked chat's (TOM-920). */
  actions?: ReactNode;
}) {
  const subtitle = boatName === null ? title : `${boatName} · ${title}`;
  return (
    <header className="neo-chat-head" data-testid="neo-chat-head">
      <span className="neo-chat-head__avatar" aria-hidden="true">
        <Icon name="tombolo" size={20} />
      </span>
      <div className="neo-chat-head__titles">
        <h1 className="neo-chat-head__name">Neo</h1>
        <p className="neo-chat-head__sub" title={subtitle}>
          {subtitle}
        </p>
      </div>
      {sources !== undefined ? (
        <button
          type="button"
          className={`neo-chat-head__sources${sources.open ? ' is-open' : ''}`}
          aria-expanded={sources.open}
          data-testid="neo-head-sources"
          onClick={sources.onToggle}
        >
          <Icon name="info" size={16} />
          <span>Sources</span>
        </button>
      ) : null}
      <button
        type="button"
        className="tb-icon-btn neo-chat-head__new"
        aria-label="New chat"
        title="New chat"
        data-testid="neo-page-new-chat"
        onClick={onNewChat}
      >
        <Icon name="plus" size={20} />
      </button>
      {actions}
    </header>
  );
}
